// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, of } from 'rxjs';

// --- HS Code
import { ResponseBaseService } from './response-base.service';
import {
  ContextQuestionModel,
  QuestionResponseModel,
  SurveyResponseContexts,
  SurveyResponseModel,
  SurveyStatuses,
} from '../../../models';
import { QuestionsBaseService } from '..';

// #endregion

@Injectable({
  providedIn: 'root',
})
export class ResponseMockService extends ResponseBaseService {
  constructor(private questionsService: QuestionsBaseService) {
    super(questionsService);
  }

  loadResponse(surveyId: string): void {
    const questionResponses = this._getQuestionResponses();

    const surveyResponse = {} as SurveyResponseModel;
    surveyResponse.status = SurveyStatuses.demographics;
    surveyResponse.responseContext = SurveyResponseContexts.participant;
    surveyResponse.questionResponses = questionResponses;
    this._activeResponse$.next(surveyResponse);
    this.initialiseQuestionResponses(
      surveyId,
      questionResponses,
      surveyResponse.responseContext
    );
  }

  updateStatus(model: SurveyResponseModel): Observable<SurveyResponseModel | null> {
    this._isUpdating$.next(true);
    this._activeResponse$.next(model);
    this._isUpdating$.next(false);
    return of(model);
  }

  updateComment(name: string, value: string): void {}

  update(model: SurveyResponseModel): Observable<boolean> {
    return of(true);
  }

  questionAnswered(response: ContextQuestionModel): void {
    const questionResponses = this._getQuestionResponses();

    let theQuestion = questionResponses.find((qr) => {
      return qr.id === response.questionResponseId;
    });

    // theQuestion = response;
  }

  private _getQuestionResponses(): QuestionResponseModel[] {
    const questionResponses = new Array<QuestionResponseModel>();

    questionResponses.push(
      Object.assign({
        id: 'R001',
        surveyId: 's1',
        questionId: '1',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R002',
        surveyId: 's1',
        questionId: '2',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R003',
        surveyId: 's1',
        questionId: '3',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R004',
        surveyId: 's1',
        questionId: '4',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R005',
        surveyId: 's1',
        questionId: '5',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R006',
        surveyId: 's1',
        questionId: '6',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R007',
        surveyId: 's1',
        questionId: '7',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R008',
        surveyId: 's1',
        questionId: '8',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R009',
        surveyId: 's1',
        questionId: '9',
        responseType: 1,
      } as QuestionResponseModel)
    );

    questionResponses.push(
      Object.assign({
        id: 'R010',
        surveyId: 's1',
        questionId: '10',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R011',
        surveyId: 's1',
        questionId: '11',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R012',
        surveyId: 's1',
        questionId: '12',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R013',
        surveyId: 's1',
        questionId: '13',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R014',
        surveyId: 's1',
        questionId: '14',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R015',
        surveyId: 's1',
        questionId: '15',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R016',
        surveyId: 's1',
        questionId: '16',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R017',
        surveyId: 's1',
        questionId: '17',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R018',
        surveyId: 's1',
        questionId: '18',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R019',
        surveyId: 's1',
        questionId: '19',
        responseType: 1,
      } as QuestionResponseModel)
    );

    questionResponses.push(
      Object.assign({
        id: 'R020',
        surveyId: 's1',
        questionId: '20',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R021',
        surveyId: 's1',
        questionId: '21',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R022',
        surveyId: 's1',
        questionId: '22',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R023',
        surveyId: 's1',
        questionId: '23',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R024',
        surveyId: 's1',
        questionId: '24',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R025',
        surveyId: 's1',
        questionId: '25',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R026',
        surveyId: 's1',
        questionId: '26',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R027',
        surveyId: 's1',
        questionId: '27',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R028',
        surveyId: 's1',
        questionId: '28',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R029',
        surveyId: 's1',
        questionId: '29',
        responseType: 1,
      } as QuestionResponseModel)
    );

    questionResponses.push(
      Object.assign({
        id: 'R030',
        surveyId: 's1',
        questionId: '30',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R031',
        surveyId: 's1',
        questionId: '31',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R032',
        surveyId: 's1',
        questionId: '32',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R033',
        surveyId: 's1',
        questionId: '33',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R034',
        surveyId: 's1',
        questionId: '34',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R035',
        surveyId: 's1',
        questionId: '35',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R036',
        surveyId: 's1',
        questionId: '36',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R037',
        surveyId: 's1',
        questionId: '37',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R038',
        surveyId: 's1',
        questionId: '38',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R039',
        surveyId: 's1',
        questionId: '39',
        responseType: 1,
      } as QuestionResponseModel)
    );

    questionResponses.push(
      Object.assign({
        id: 'R040',
        surveyId: 's1',
        questionId: '40',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R041',
        surveyId: 's1',
        questionId: '41',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R042',
        surveyId: 's1',
        questionId: '42',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R043',
        surveyId: 's1',
        questionId: '43',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R044',
        surveyId: 's1',
        questionId: '44',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R045',
        surveyId: 's1',
        questionId: '45',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R046',
        surveyId: 's1',
        questionId: '46',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R047',
        surveyId: 's1',
        questionId: '47',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R048',
        surveyId: 's1',
        questionId: '48',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R049',
        surveyId: 's1',
        questionId: '49',
        responseType: 1,
      } as QuestionResponseModel)
    );

    questionResponses.push(
      Object.assign({
        id: 'R050',
        surveyId: 's1',
        questionId: '50',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R051',
        surveyId: 's1',
        questionId: '51',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R052',
        surveyId: 's1',
        questionId: '52',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R053',
        surveyId: 's1',
        questionId: '53',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R054',
        surveyId: 's1',
        questionId: '54',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R055',
        surveyId: 's1',
        questionId: '55',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R056',
        surveyId: 's1',
        questionId: '56',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R057',
        surveyId: 's1',
        questionId: '57',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R058',
        surveyId: 's1',
        questionId: '58',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R059',
        surveyId: 's1',
        questionId: '59',
        responseType: 1,
      } as QuestionResponseModel)
    );

    questionResponses.push(
      Object.assign({
        id: 'R060',
        surveyId: 's1',
        questionId: '60',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R061',
        surveyId: 's1',
        questionId: '61',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R062',
        surveyId: 's1',
        questionId: '62',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R063',
        surveyId: 's1',
        questionId: '63',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R064',
        surveyId: 's1',
        questionId: '64',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R065',
        surveyId: 's1',
        questionId: '65',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R066',
        surveyId: 's1',
        questionId: '66',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R067',
        surveyId: 's1',
        questionId: '67',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R068',
        surveyId: 's1',
        questionId: '68',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R069',
        surveyId: 's1',
        questionId: '69',
        responseType: 1,
      } as QuestionResponseModel)
    );

    questionResponses.push(
      Object.assign({
        id: 'R070',
        surveyId: 's1',
        questionId: '70',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R071',
        surveyId: 's1',
        questionId: '71',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R072',
        surveyId: 's1',
        questionId: '72',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R073',
        surveyId: 's1',
        questionId: '73',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R074',
        surveyId: 's1',
        questionId: '74',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R075',
        surveyId: 's1',
        questionId: '75',
        responseType: 1,
      } as QuestionResponseModel)
    );

    questionResponses.push(
      Object.assign({
        id: 'R076',
        surveyId: 's1',
        questionId: '1',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R077',
        surveyId: 's1',
        questionId: '2',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R078',
        surveyId: 's1',
        questionId: '3',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R079',
        surveyId: 's1',
        questionId: '4',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R080',
        surveyId: 's1',
        questionId: '5',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R081',
        surveyId: 's1',
        questionId: '6',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R082',
        surveyId: 's1',
        questionId: '7',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R083',
        surveyId: 's1',
        questionId: '8',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R084',
        surveyId: 's1',
        questionId: '9',
        responseType: 2,
      } as QuestionResponseModel)
    );

    questionResponses.push(
      Object.assign({
        id: 'R085',
        surveyId: 's1',
        questionId: '10',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R086',
        surveyId: 's1',
        questionId: '11',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R087',
        surveyId: 's1',
        questionId: '12',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R088',
        surveyId: 's1',
        questionId: '13',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R089',
        surveyId: 's1',
        questionId: '14',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R090',
        surveyId: 's1',
        questionId: '15',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R091',
        surveyId: 's1',
        questionId: '16',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R092',
        surveyId: 's1',
        questionId: '17',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R093',
        surveyId: 's1',
        questionId: '18',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R094',
        surveyId: 's1',
        questionId: '19',
        responseType: 2,
      } as QuestionResponseModel)
    );

    questionResponses.push(
      Object.assign({
        id: 'R095',
        surveyId: 's1',
        questionId: '20',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R096',
        surveyId: 's1',
        questionId: '21',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R097',
        surveyId: 's1',
        questionId: '22',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R098',
        surveyId: 's1',
        questionId: '23',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R099',
        surveyId: 's1',
        questionId: '24',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R100',
        surveyId: 's1',
        questionId: '25',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R101',
        surveyId: 's1',
        questionId: '26',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R102',
        surveyId: 's1',
        questionId: '27',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R103',
        surveyId: 's1',
        questionId: '28',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R104',
        surveyId: 's1',
        questionId: '29',
        responseType: 2,
      } as QuestionResponseModel)
    );

    questionResponses.push(
      Object.assign({
        id: 'R105',
        surveyId: 's1',
        questionId: '30',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R106',
        surveyId: 's1',
        questionId: '31',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R107',
        surveyId: 's1',
        questionId: '32',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R108',
        surveyId: 's1',
        questionId: '33',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R109',
        surveyId: 's1',
        questionId: '34',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R110',
        surveyId: 's1',
        questionId: '35',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R111',
        surveyId: 's1',
        questionId: '36',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R112',
        surveyId: 's1',
        questionId: '37',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R113',
        surveyId: 's1',
        questionId: '38',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R114',
        surveyId: 's1',
        questionId: '39',
        responseType: 2,
      } as QuestionResponseModel)
    );

    questionResponses.push(
      Object.assign({
        id: 'R115',
        surveyId: 's1',
        questionId: '40',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R116',
        surveyId: 's1',
        questionId: '41',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R117',
        surveyId: 's1',
        questionId: '42',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R118',
        surveyId: 's1',
        questionId: '43',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R119',
        surveyId: 's1',
        questionId: '44',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R120',
        surveyId: 's1',
        questionId: '45',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R121',
        surveyId: 's1',
        questionId: '46',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R122',
        surveyId: 's1',
        questionId: '47',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R123',
        surveyId: 's1',
        questionId: '48',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R124',
        surveyId: 's1',
        questionId: '49',
        responseType: 2,
      } as QuestionResponseModel)
    );

    questionResponses.push(
      Object.assign({
        id: 'R125',
        surveyId: 's1',
        questionId: '50',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R126',
        surveyId: 's1',
        questionId: '51',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R127',
        surveyId: 's1',
        questionId: '52',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R128',
        surveyId: 's1',
        questionId: '53',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R129',
        surveyId: 's1',
        questionId: '54',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R130',
        surveyId: 's1',
        questionId: '55',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R131',
        surveyId: 's1',
        questionId: '56',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R132',
        surveyId: 's1',
        questionId: '57',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R133',
        surveyId: 's1',
        questionId: '58',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R134',
        surveyId: 's1',
        questionId: '59',
        responseType: 2,
      } as QuestionResponseModel)
    );

    questionResponses.push(
      Object.assign({
        id: 'R135',
        surveyId: 's1',
        questionId: '60',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R136',
        surveyId: 's1',
        questionId: '61',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R137',
        surveyId: 's1',
        questionId: '62',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R138',
        surveyId: 's1',
        questionId: '63',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R139',
        surveyId: 's1',
        questionId: '64',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R140',
        surveyId: 's1',
        questionId: '65',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R141',
        surveyId: 's1',
        questionId: '66',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R142',
        surveyId: 's1',
        questionId: '67',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R143',
        surveyId: 's1',
        questionId: '68',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R144',
        surveyId: 's1',
        questionId: '69',
        responseType: 2,
      } as QuestionResponseModel)
    );

    questionResponses.push(
      Object.assign({
        id: 'R145',
        surveyId: 's1',
        questionId: '70',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R146',
        surveyId: 's1',
        questionId: '71',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R147',
        surveyId: 's1',
        questionId: '72',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R148',
        surveyId: 's1',
        questionId: '73',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R149',
        surveyId: 's1',
        questionId: '74',
        responseType: 2,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R150',
        surveyId: 's1',
        questionId: '75',
        responseType: 2,
      } as QuestionResponseModel)
    );

    questionResponses.push(
      Object.assign({
        id: 'R151',
        surveyId: 's1',
        questionId: '76',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R152',
        surveyId: 's1',
        questionId: '77',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R153',
        surveyId: 's1',
        questionId: '78',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R154',
        surveyId: 's1',
        questionId: '79',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R155',
        surveyId: 's1',
        questionId: '80',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R156',
        surveyId: 's1',
        questionId: '81',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R157',
        surveyId: 's1',
        questionId: '82',
        responseType: 1,
      } as QuestionResponseModel)
    );
    questionResponses.push(
      Object.assign({
        id: 'R158',
        surveyId: 's1',
        questionId: '83',
        responseType: 1,
      } as QuestionResponseModel)
    );

    return questionResponses;
  }

  onNext(
    resposne: SurveyResponseModel,
    isEffectivenessNext: boolean = false
  ): void {
    throw new Error('Method not implemented.');
  }
}
